<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">Document Submission</h1>
                <poi-documents-form
                    :validation="validation"
                    @submit="onSubmit"
                />
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import PoiDocumentsForm from '@product-common/components/investor/PoiDocumentsForm';
import ProfileHeader from '@investor/components/profile/ProfileHeader';

export default {
    components: {
        ProfileHeader,
        PoiDocumentsForm,
    },
    data() {
        return {
            validation: {
                fieldErrors: {}
            }
        }
    },
    methods: {
        async onSubmit(form) {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('registration/poi-documents', form);
                await this.$fetchInvestorProfile();
                await this.$routeInvestor();
                //this.$trackGAEvent('poi', 'docs-upload');
            } catch (error) {
                console.error(error)
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                }
            }
        },
    }
}
</script>


